import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUpload,
  faTrophy,
  faList,
  faBriefcase,
} from "@fortawesome/free-solid-svg-icons";
import SponsorAds from "./SponsorAds";
import { useEffect, useState } from 'react';
import API from '../api/axios';

const menuItems = [
  { label: "Home", path: "/", icon: faHome },
  { label: "Add Project", path: "/submit-project", icon: faUpload },
  { label: "LaunchBoard", path: "/launchBoard", icon: faTrophy },
  { label: "My Projects", path: "/my-projects", icon: faBriefcase },
  { label: "Categories", path: "/category", icon: faList },
];

export default function LeftSidebar() {
  const location = useLocation();
  const [sidebarAds, setSidebarAds] = useState([]);
  const isLaunchBoard = location.pathname === "/launchBoard";

  useEffect(() => {
    API.get("/ad-slots/")
      .then((res) => {
        if (res.data?.success && Array.isArray(res.data.data)) {
          const filteredAds = res.data.data
            .filter((ad) => {
              if (isLaunchBoard) {
                return  (ad.placement === "sidebar" || ad.placement === "leftsidebar" || ad.placement === "leaderboard")  && ad.status === "active";
              }
              return (
                (ad.placement === "sidebar" || ad.placement === "leftsidebar") &&
                ad.status === "active"
              );
            })
            .map((ad) => ({
              type: ad.type,
              image: ad.image_url,
              link: ad.target_url || "#",
              embed_code: ad.embed_code,
            }));

          setSidebarAds(filteredAds);
        }
      })
      .catch((err) => console.error("Ad slots fetch failed:", err));
  }, [isLaunchBoard]);


  return (
    <div className="leftSidebar">
    <div className="wrapper">
      {/* Sidebar Menu */}
      <ul className="list-unstyled sidebar-menu">
        {menuItems.map(({ label, path, icon }) => (
          <li key={path} className={location.pathname === path ? "active" : ""}>
            <Link to={path}>
              <FontAwesomeIcon icon={icon} /> <span>{label}</span>
            </Link>
          </li>
        ))}
      </ul>

      {/* Sponsor Ads Slider */}
      <SponsorAds ads={sidebarAds} />
      </div>
    </div>
  );
}
